import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FileUpload } from 'src/app/models';


@Component({
    selector: 'app-input-uploader',
    templateUrl: './input-uploader.component.html',
    styleUrls: ['./input-uploader.component.scss'],
    standalone: false
})
export class InputUploaderComponent implements OnInit {

  @Input() id: string;
  @Input() title: string;
  @Input() selector: string;
  @Input() tooltipText : string = "Drag and drop your files here or click to upload them";
  @Input() multiple : boolean = true;
  @Output() sendInfoToParent: EventEmitter<FileList> = new EventEmitter();
  response: FileUpload;
  files: FileList;
  uploadFileInput: string;

  constructor() { }

  ngOnInit() { }

  /**
   * Returns the file selected from the pc and sends it to the parent component
   * @param $event Selected file
   */

  onSelect($event: Event) {
    //console.log("on-select")
    // console.log($event);
    this.files = ($event.target as HTMLInputElement).files;
    this.sendInfoToParent.emit(this.files);
    // Reset ngModel to update again the same file
    this.uploadFileInput = '';
  }

  /**
   * Returns the file or the files dragged into the input and sends it to the parent component
   * @param $event Dragged file/files
   */

  onFileDropped($event: File[]) {
    this.files = $event as unknown as FileList;
    this.sendInfoToParent.emit(this.files);
  }
}
